import React from 'react';
import { Line as KonvaLine } from 'react-konva';

/**
 * Thin declarative wrapper around Konva Line.
 * Usage: <Line points={[x1, y1, x2, y2, ...]} />
 */
export const Line: React.FC<{
    points: number[];
    strokeWidth?: number;
    stroke?: string;
    closed?: boolean;
}> = React.memo(({ points, strokeWidth = 1, stroke = 'black', closed }) => (
    <KonvaLine
        points={points}
        stroke={stroke}
        strokeWidth={strokeWidth}
        closed={closed}
    />
));